module.exports = __webpack_public_path__ + "img/图片2.5ca8d6ed.png";